import {createSlice, PayloadAction} from '@reduxjs/toolkit';

export interface ITutorialLayoutState {
  greetingsViewPosition: {positionY: number};
  qrCodeViewPosition: {positionY: number};
  locationDropdownPosition: {positionY: number};
  notificationIconPosition: {positionY: number};
  quickFundButtonPosition: {positionY: number};
}

export const initialState: ITutorialLayoutState = {
  greetingsViewPosition: {positionY: 0},
  qrCodeViewPosition: {positionY: 0},
  locationDropdownPosition: {positionY: 0},
  notificationIconPosition: {positionY: 0},
  quickFundButtonPosition: {positionY: 0},
};

const tutorialLayoutSlice = createSlice({
  name: 'tutorialLayout',
  initialState,
  reducers: {
    setGreetingViewPosition: (
      state,
      action: PayloadAction<{positionY: number}>,
    ) => {
      state.greetingsViewPosition = action.payload;
    },
    setQRCodeViewPosition: (
      state,
      action: PayloadAction<{positionY: number}>,
    ) => {
      state.qrCodeViewPosition = action.payload;
    },
    setLocationDropdownPosition: (
      state,
      action: PayloadAction<{positionY: number}>,
    ) => {
      state.locationDropdownPosition = action.payload;
    },
    setNotificationIconPosition: (
      state,
      action: PayloadAction<{positionY: number}>,
    ) => {
      state.notificationIconPosition = action.payload;
    },
    setQuickFundButtonPosition: (
      state,
      action: PayloadAction<{positionY: number}>,
    ) => {
      state.quickFundButtonPosition = action.payload;
    },
  },
});

export const {
  setGreetingViewPosition,
  setQRCodeViewPosition,
  setLocationDropdownPosition,
  setNotificationIconPosition,
  setQuickFundButtonPosition,
} = tutorialLayoutSlice.actions;
export default tutorialLayoutSlice.reducer;
